<script setup lang="ts">
import { useRoute } from 'vue-router'
import { computed, watch } from 'vue'
import TabBar from './components/tabbar/index.vue'
import { useAppStore } from './stores/app'
import { useAppBootstrap } from './hooks/useAppBootstrap'

const route = useRoute()
const appStore = useAppStore()

// 应用启动编排：SignalR 连接、realtimeSync 启停、登出清理
useAppBootstrap()

watch(
  () => route.meta.showTabBar,
  showTabBarMeta => {
    appStore.syncTabBarVisibility(showTabBarMeta as boolean | undefined)
  },
  { immediate: true },
)

const mainClass = computed(() => {
  if (appStore.isMobile) {
    return appStore.shouldShowTabBar ? 'h-[calc(100vh-56px)] w-full' : 'h-screen w-full'
  }
  return 'h-screen flex-1 min-w-0'
})

const appContainerStyle = computed(() => {
  if (!appStore.isMobile) return undefined
  return {
    height: '100dvh',
  }
})

const mainStyle = computed(() => {
  if (!appStore.isMobile) return undefined
  if (appStore.shouldShowTabBar) {
    return {
      height: 'calc(100dvh - 56px - env(safe-area-inset-bottom, 0px))',
    }
  }
  return {
    height: '100dvh',
  }
})
</script>

<template>
  <van-config-provider theme="dark">
    <div
      class="h-screen bg-gray-950 text-white"
      :class="[appStore.isMobile ? '' : 'flex flex-row-reverse']"
      :style="appContainerStyle"
    >
      <main :class="mainClass" :style="mainStyle" class="flex flex-col">
        <router-view v-slot="{ Component }">
          <keep-alive>
          <component :is="Component" v-if="route.meta.keepAlive" :key="route.name" />
          </keep-alive>
          <component :is="Component" v-if="!route.meta.keepAlive" :key="route.name" />
        </router-view>
      </main>
      <TabBar />
    </div>
  </van-config-provider>
</template>
